const initialState = {
    isModalVisible: false,
  };
  
  const vehiclesModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_VEHICLES_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_VEHICLES_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default vehiclesModalReducer;
  